export interface NotificationResponse {
  data: NotificationData;
  message: string;
  code: number;
}

export interface NotificationData {
  notifications: Notification[];
  unreadCount: number;
}

export interface Notification {
  notification_id: number;
  notification_user_id: number;
  notification_form_id: number;
  notification_answer_id: number;
  notification_sender_role_value: string;
  notification_email_template_id: number;
  notification_type_id: number;
  notification_sender_name: string;
  notification_is_read: boolean;
  notification_created_by: number;
  notification_created_date: string;
  notification_is_deleted: boolean;
  notification_is_automatic: boolean;
  type: NotificationType;
  email_template: EmailTemplate;
  form?: {
    form_name?: string | null;
    // otros campos que tenga el form…
  } | null;

  // si también llega form_name plano:
  form_name?: string | null;
}

export interface NotificationType {
  general_type_id: number;
  general_type_type: string;
  general_type_description: string;
  general_type_value: string;
  general_type_is_deleted: boolean;
  general_type_create_by: number;
  general_type_create_date: string | null;
  general_type_update_by: number | null;
  general_type_update_date: string | null;
}

export interface EmailTemplate {
  email_template_title: string;
  email_template_type: string;
}

export interface Form {
  form_name: string;
}

export interface MarkAsReadResponse {
  data: NotificationMarked;
  message: string;
  code: number;
}

export interface NotificationMarked {
  notification_id: number;
  notification_user_id: number;
  notification_form_id: number;
  notification_answer_id: number;
  notification_sender_role_value: string;
  notification_email_template_id: number;
  notification_type_id: number;
  notification_sender_name: string;
  notification_is_read: boolean;
  notification_created_by: number;
  notification_created_date: string;
  notification_is_deleted: boolean;
}

export enum endpoint {
  getNotifications = 'notifications',
  markAsReadNotification = 'notifications/is-read',
  markAllAsRead = 'notifications/is-read-all',
  loadHasUnread = 'notifications/has-unread-notifications',
}
